import script from "./CustomMultiplePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMultiplePicker.vue?vue&type=script&setup=true&lang=ts"

import "./CustomMultiplePicker.vue?vue&type=style&index=0&id=4645534d&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4645534d"]])

export default __exports__